<!--
 * @Author: 汪鑫
 @Description:  v2.0.7版本后新增自定义字段添加组件
-->
<template >
  <div class="newAddFiled">
    <!-- 新版样式 v.2.0.8.1 -->
    <el-col :span="24" class="add-customize-field" v-if="isNewStyle">
      <el-form
        :model="formData"
        :rules="formRules"        
        ref="form"
      >
        <el-col :span="24" style="display:flex" class="new-add-col">
          <el-form-item label="新增字段" prop="title" :label-width="labelW + 'px'" style="margin-right:10px" class="new-add-box">
            <el-input
              :style="{ width: titleW + 'px' }"
              maxlength="20"
              @input="(title) => updateContent({ title })"
              :value="formData.title"
              autocomplete="off"
              class="new-add-title"
              placeholder="请输入字段名称"
            ></el-input>
          </el-form-item>
          <el-form-item prop="value" class="new-add-value new-add-box">
            <el-input
              :style="{ width: valueW + 'px' }"
              maxlength="200"
              @input="(value) => updateContent({ value })"
              :value="formData.value"
              autocomplete="off"
              class="new-add-content"
              placeholder="请输入字段内容"
            ></el-input>
            <span @click="$emit('deleteItem', formData.key)">
              <el-icon class="el-icon-delete delete-icon"></el-icon>
            </span>
          </el-form-item>
        </el-col>
      </el-form>
    </el-col>
  </div>
</template>

<script>
export default {
  name: "AddBtnCustomizeField",
  props: {
    isNewStyle:{//默认旧版样式
      type: Boolean,
      default: false,
    },
    titleW:{
      //字段名称输入框宽度
      type: Number,
      default: 300,
    },
    valueW:{
      //字段内容输入框宽度
      type: Number,
      default: 742,
    },
    formData: {
      //新增字段对象
      type: Object,
      default() {
        return {};
      },
    },
    labelW: {
      //表单宽度
      type: Number,
      default: 114,
    },
    w: {
      //旧版输入框宽度
      type: [Number, String],
      default: "100%",
    },
    isWidth: {
      //设置了输入框宽度删除按钮定位
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      formRules: {
        title: [{ required: true, message: "请输入字段名称", trigger: "blur" }],
        value: [{ required: true, message: "请输入字段内容", trigger: "blur" }],
      },
    };
  },
  methods: {
    updateContent({
      title = this.formData.title,
      value = this.formData.value,
      key = this.formData.key,
    }) {
      this.$emit("updateContent", { title, value, key });
    },
    validateForm() {
      return this.$refs.form.validate();
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-form-item__label{
  height: 34px!important;
  line-height: 34px;
}
/deep/.el-input__inner{
  height: 34px!important;
  line-height: 34px;
}
/deep/.el-form-item__content{
  height: 34px!important;
  line-height: 34px;
}
.add-customize-field {
  .el-input {
    .el-input__inner {
      height: 34px;
    }
  }
  .icon-delete1 {
    position: absolute;
    top: 12px;
    right: -16px;
  }
  .icon-delete {
    margin-left: 6px;
    font-size: 14px;
    color: #FF6600;
    cursor: pointer;
  }
  .delete-icon{
    margin-left: 10px;
    font-size: 14px;
    color: #FF6600;
    cursor: pointer;
  }
}
.btn-add {
  padding: 10px 17px;
  color: #0286DF;
  border-color: #0286DF;
  background-color: #ffffff !important;
}
</style>
